(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["order-sample-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('order-sample-button')) {
    class OrderSampleButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');

        if (!this.button || this.button.disabled) return;

        this.defaultText = this.querySelector('.order-sample__default-text');
        this.loadingText = this.querySelector('.order-sample__loading-text');
        this.addedText = this.querySelector('.order-sample__added-text');
        this.errorMessage = this.querySelector('.order-sample__error');

        this.button.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
      }

      handleClick = async () => {
        if (this.button.disabled) return;

        this.setLoading(true);
        this.clearError();

        try {
          const usedNativeCartAction = await this.addSample();

          /*
           * When Ajax fallback is used, addSample redirects to the
           * full cart page. No further cart-opening action is needed.
           */
          if (!usedNativeCartAction) return;

          this.showAddedState();

          if (this.dataset.openCart === 'true') {
            await this.openCart();
          }
        } catch (error) {
          this.showError(
            error instanceof Error
              ? error.message
              : 'The sample could not be added. Please try again.'
          );
        } finally {
          this.setLoading(false);
        }
      };

      async addSample() {
        /*
         * Preferred method for newer Shopify themes.
         * This should update the theme cart and cart drawer automatically.
         */
        if (
          window.Shopify?.actions &&
          typeof window.Shopify.actions.updateCart === 'function'
        ) {
          const response = await window.Shopify.actions.updateCart(
            {
              lines: [
                {
                  merchandiseId: this.dataset.variantGid,
                  quantity: 1
                }
              ]
            },
            {
              event: {
                context: 'product',
                detail: {
                  source: 'order-sample-button'
                }
              }
            }
          );

          const userError = response?.userErrors?.[0];

          if (userError) {
            throw new Error(userError.message);
          }

          return true;
        }

        /*
         * Fallback for themes where Shopify.actions is unavailable.
         * The customer is redirected to the cart after the item is added,
         * ensuring the cart displays the new sample correctly.
         */
        const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(this.dataset.variantId),
                quantity: 1
              }
            ]
          })
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'The sample could not be added.'
          );
        }

        window.location.href = this.dataset.cartUrl;

        return false;
      }

      async openCart() {
        if (
          window.Shopify?.actions &&
          typeof window.Shopify.actions.openCart === 'function'
        ) {
          await window.Shopify.actions.openCart();
          return;
        }

        window.location.href = this.dataset.cartUrl;
      }

      setLoading(isLoading) {
        this.button.disabled = isLoading;
        this.button.setAttribute('aria-busy', String(isLoading));

        this.defaultText.hidden = isLoading;
        this.loadingText.hidden = !isLoading;

        if (isLoading) {
          this.addedText.hidden = true;
        }
      }

      showAddedState() {
        this.defaultText.hidden = true;
        this.loadingText.hidden = true;
        this.addedText.hidden = false;

        window.setTimeout(() => {
          this.addedText.hidden = true;
          this.defaultText.hidden = false;
        }, 2000);
      }

      showError(message) {
        this.errorMessage.textContent = message;
        this.errorMessage.hidden = false;
      }

      clearError() {
        this.errorMessage.textContent = '';
        this.errorMessage.hidden = true;
      }
    }

    customElements.define('order-sample-button', OrderSampleButton);
  }
  } catch(e) { console.error(e); }
})();

})();
